import { render, staticRenderFns } from "./confirm-ok-drawer.vue?vue&type=template&id=0b819446"
import script from "./confirm-ok-drawer.vue?vue&type=script&lang=js"
export * from "./confirm-ok-drawer.vue?vue&type=script&lang=js"
import style0 from "./confirm-ok-drawer.vue?vue&type=style&index=0&id=0b819446&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports